<template>
  <div class="plazza-search-page">
    <div class="search-header">
      <div class="header-back" @click="$router.go(-1)">
        <svg viewBox="0 0 24 24" width="0.5rem" height="0.5rem" fill="none" stroke="#fff" stroke-width="2">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
      </div>
      <div class="header-title">搜索</div>
    </div>
    <div class="search-bar">
      <input type="text" v-model="keyword" placeholder="请输入搜索内容" @keyup.enter="handleSearch" />
      <span class="search-clear" v-if="keyword" @click="keyword = ''">
        <span class="clear-circle">
          <svg viewBox="0 0 24 24" width="0.3rem" height="0.3rem" fill="#000">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </span>
      </span>
      <svg class="search-btn" viewBox="0 0 24 24" width="0.4rem" height="0.4rem" fill="none" stroke="#d1ae52" stroke-width="2" @click="handleSearch">
        <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
      </svg>
    </div>

    <!-- 搜索结果 -->
    <div class="search-results" v-if="searched">
      <div class="post-list" v-if="postList.length > 0">
        <div class="post-item" v-for="(post, idx) in postList" :key="post.id" :class="{ 'is-self': post.is_self }">
          <div class="post-header">
            <div class="post-user-info">
              <img :src="$imgUrl(post.plazza_avatar ? post.plazza_avatar : '/static/newImg/avatar/default.webp')" class="post-avatar" />
              <div class="post-user-text">
                <span class="post-username">{{ post.plazza_username ? post.plazza_username : post.username }}</span>
                <span class="post-fans">{{ post.followers_count || 0 }}位粉丝</span>
              </div>
            </div>
            <div v-if="!post.is_self" class="post-follow-btn" @click="handleFollow(post)">
              {{ post.is_followed ? '已关注' : '+关注' }}
            </div>
          </div>
          <div class="post-content-text">{{ post.content }}</div>
          <div class="post-image-grid" v-if="post.images && parseImages(post.images).length > 0" :class="{
            'grid-1': parseImages(post.images).length === 1,
            'grid-2': parseImages(post.images).length === 2,
            'grid-3': parseImages(post.images).length >= 3
          }">
            <img
              v-for="(img, imgIdx) in parseImages(post.images)"
              :key="imgIdx"
              :src="img"
              class="post-grid-img"
            />
          </div>
          <div class="post-footer">
            <span class="post-date">{{ formatTime(post.created_at) }}</span>
            <div class="post-actions">
              <span class="action-item" @click="handleReward(post)">
                <span class="action-icon reward-icon">🎁</span> 打赏
              </span>
              <span class="action-item" @click="handleLike(post)">
                <img :src="post.is_liked ? '/static/newImg/plazza_like_on.svg' : '/static/newImg/plazza_like_off.svg'" class="like-icon-img" /> {{ post.likes_count || 0 }}
              </span>
              <span class="action-item" @click="handleFavorite(post)">
                <img :src="post.is_favorited ? '/static/newImg/plazza_favorite_on.svg' : '/static/newImg/plazza_favorite_off.svg'" class="favorite-icon-img" /> {{ post.favorites_count || 0 }}
              </span>
              <span class="action-item" @click="handleShare(post)"><img src="/static/newImg/plazza_share_icon.svg" class="share-icon-img" /> 分享</span>
            </div>
          </div>
        </div>
      </div>
      <div class="loading" v-if="loading">
        <p>加载中...</p>
      </div>
      <div class="empty-state" v-if="!loading && postList.length === 0">
        <img src="/static/image/img_none_sj.avif" class="empty-icon" />
        <p class="empty-text">没有找到相关内容</p>
      </div>
    </div>

    <PlazzaRewardModal
      :visible.sync="rewardModalVisible"
      :post="rewardPost"
      @success="onRewardSuccess"
    />
  </div>
</template>

<script>
import PlazzaRewardModal from './PlazzaRewardModal.vue';
export default {
  name: 'PlazzaSearch',
  components: { PlazzaRewardModal },
  data() {
    return {
      keyword: '',
      searched: false,
      postList: [],
      loading: false,
      page: 1,
      pageSize: 10,
      hasMore: false,
      actionLocks: {},
      currentUserInfo: {
        plazza_username: '',
        plazza_avatar: '',
      },
      rewardModalVisible: false,
      rewardPost: null,
    }
  },
  mounted() {
    this.loadCurrentUserInfo();
    this.__handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const viewHeight = window.innerHeight || document.documentElement.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight || 0;
      if (scrollHeight - (scrollTop + viewHeight) < 50) {
        if (!this.loading && this.hasMore) {
          this.page += 1;
          this.loadSearchResults(false);
        }
      }
    };
    window.addEventListener('scroll', this.__handleScroll, { passive: true });
  },
  beforeDestroy() {
    if (this.__handleScroll) {
      window.removeEventListener('scroll', this.__handleScroll);
    }
  },
  methods: {
    loadCurrentUserInfo() {
      this.$apiFun.post('/api/plazza/myprofile').then(res => {
        if (res.code === 200) {
          this.currentUserInfo.plazza_username = res.data.plazza_username || '';
          this.currentUserInfo.plazza_avatar = res.data.plazza_avatar || '';
        }
      }).catch(e => {
        console.error('加载用户信息失败', e);
      });
    },
    checkUserProfile() {
      if (!this.currentUserInfo.plazza_username || !this.currentUserInfo.plazza_avatar) {
        this.$toast('请先设置社区昵称和头像');
        return false;
      }
      return true;
    },
    checkCooldown(key) {
      const now = Date.now();
      const lastTime = this.actionLocks[key] || 0;
      if (now - lastTime < 3000) {
        this.$toast('你点击的太快了');
        return false;
      }
      this.actionLocks[key] = now;
      return true;
    },
    handleSearch() {
      if (!this.keyword.trim()) return;
      this.page = 1;
      this.postList = [];
      this.searched = true;
      this.loadSearchResults(true);
    },
    loadSearchResults(reset) {
      if (this.loading) return;
      this.loading = true;
      this.$apiFun.post('/api/plazza/posts', {
        type: 'all',
        keyword: this.keyword.trim(),
        page: this.page,
        pageSize: this.pageSize,
      }).then(res => {
        if (res.code === 200) {
          if (reset) {
            this.postList = res.data.list || [];
          } else {
            this.postList = this.postList.concat(res.data.list || []);
          }
          this.hasMore = (res.data.page * this.pageSize) < res.data.total;
        }
      }).catch(e => {
        console.error('搜索失败', e);
      }).then(() => {
        this.loading = false;
      });
    },
    parseImages(images) {
      if (!images) return [];
      var self = this;
      var makeFullUrl = function (src) {
        return self.$imgUrl(src);
      };
      if (Array.isArray(images)) return images.map(makeFullUrl);
      try {
        const parsed = JSON.parse(images);
        if (Array.isArray(parsed)) return parsed.map(makeFullUrl);
        return [makeFullUrl(images)];
      } catch (e) {
        return [makeFullUrl(images)];
      }
    },
    formatTime(time) {
      if (!time) return '';
      const date = new Date(time);
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const h = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      return `${y}/${m}/${d} ${h}:${min}`;
    },
    handleLike(post) {
      const lockKey = 'like_' + post.id;
      if (!this.checkCooldown(lockKey)) return;
      if (post.is_self) return;
      if (!this.checkUserProfile()) return;
      this.$apiFun.post('/api/plazza/post/like', { post_id: post.id }).then(res => {
        if (res.code === 200) {
          post.is_liked = res.data.is_liked;
          post.likes_count = res.data.likes_count;
          this.$toast(res.data.is_liked ? '点赞成功' : '取消点赞');
        }
      }).catch(e => { console.error('点赞失败', e); });
    },
    handleFavorite(post) {
      const lockKey = 'fav_' + post.id;
      if (!this.checkCooldown(lockKey)) return;
      if (post.is_self) return;
      if (!this.checkUserProfile()) return;
      this.$apiFun.post('/api/plazza/post/favorite', { post_id: post.id }).then(res => {
        if (res.code === 200) {
          post.is_favorited = res.data.is_favorited;
          post.favorites_count = res.data.favorites_count;
          this.$toast(res.data.is_favorited ? '收藏成功' : '取消收藏');
        }
      }).catch(e => { console.error('收藏失败', e); });
    },
    handleFollow(post) {
      const lockKey = 'follow_' + post.user_id;
      if (!this.checkCooldown(lockKey)) return;
      if (!this.checkUserProfile()) return;
      this.$apiFun.post('/api/plazza/post/follow', { follow_user_id: post.user_id }).then(res => {
        if (res.code === 200) {
          post.is_followed = res.data.is_followed;
          this.$toast(res.data.is_followed ? '关注成功' : '取消关注');
        }
      }).catch(e => { console.error('关注失败', e); });
    },
    handleReward(post) {
      if (post.is_self) return;
      if (!this.checkUserProfile()) return;
      this.rewardPost = post;
      this.rewardModalVisible = true;
    },
    onRewardSuccess(data) {
      var targetPost = (this.postList || []).find(p => p.id === (this.rewardPost && this.rewardPost.id));
      if (targetPost && data && typeof data.rewards_count !== 'undefined') {
        targetPost.rewards_count = data.rewards_count;
      }
    },
    handleShare(post) {
      if (!this.checkUserProfile()) return;
      this.$toast('分享功能开发中');
    },
  }
}
</script>

<style lang="scss" scoped>
.plazza-search-page {
  min-height: 100vh;
  background: #0a0a0a;
  color: #fff;
}

.search-header {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0.3rem;

  .header-back {
    position: absolute;
    left: 0.3rem;
    display: flex;
    align-items: center;
  }

  .header-title {
    font-size: 0.4rem;
    font-weight: normal;
    color: #fff;
  }
}

.search-bar {
  display: flex;
  align-items: center;
  margin: 0.3rem;
  padding: 0.25rem 0.2rem;
  background: #0a0a0a;
  border: 1px solid #666666;
  border-radius: 0.5rem;
  transition: border-color 0.3s;

  &:focus-within {
    border-color: #d1ae52;
  }

  input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    color: #fff;
    font-size: 0.35rem;
    padding: 0 0.2rem;

    &::placeholder {
      color: #666;
    }
  }

  .search-clear {
    display: flex;
    align-items: center;
    margin-right: 0.2rem;

    .clear-circle {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 50%;
      background: #666666;
      cursor: pointer;
    }
  }

  .search-btn {
    flex-shrink: 0;
    cursor: pointer;
  }
}

.search-results {
  padding: 0 0.3rem;
}

.post-list {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding-bottom: 0.3rem;
}

.post-item {
  background: #141414;
  border-radius: 0.2rem;
  padding: 0.3rem;

  .post-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.2rem;
  }

  .post-user-info {
    display: flex;
    align-items: center;
  }

  .post-avatar {
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 50%;
    margin-right: 0.2rem;
    object-fit: cover;
  }

  .post-user-text {
    display: flex;
    flex-direction: column;
  }

  .post-username {
    font-size: 0.3rem;
    color: #fff;
  }

  .post-fans {
    font-size: 0.24rem;
    color: #999;
    margin-top: 0.1rem;
  }

  .post-follow-btn {
    padding: 0.1rem 0.3rem;
    font-size: 0.28rem;
    color: #703904;
    background: #d1ae52;
    border-radius: 0.1rem;
  }

  .post-content-text {
    font-size: 0.35rem;
    color: #e3e3e3;
    line-height: 1.5;
    margin-bottom: 0.2rem;
    word-break: break-all;
  }

  .post-image-grid {
    display: grid;
    gap: 0.1rem;
    margin-bottom: 0.2rem;

    &.grid-1 {
      grid-template-columns: 1fr;
      .post-grid-img {
        width: 60%;
        height: 4rem;
        object-fit: cover;
      }
    }
    &.grid-2 {
      grid-template-columns: repeat(2, 1fr);
      grid-auto-rows: 1fr;
    }
    &.grid-3 {
      grid-template-columns: repeat(3, 1fr);
      grid-auto-rows: 1fr;
    }

    .post-grid-img {
      width: 100%;
      border-radius: 0.1rem;
      aspect-ratio: 1 / 1;
      height: auto;
      object-fit: cover;
      display: block;
    }
  }

  .post-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 0.15rem;
    border-top: 1px solid #2a2a2a;
  }

  .post-date {
    font-size: 0.24rem;
    color: #666;
  }

  .post-actions {
    display: flex;
    align-items: center;
    gap: 0.3rem;

    .action-item {
      display: flex;
      align-items: center;
      gap: 0.05rem;
      font-size: 0.26rem;
      color: #999;
      cursor: pointer;

      &:active {
        opacity: 0.7;
      }

      .like-icon-img,
      .favorite-icon-img,
      .share-icon-img {
        width: 0.45rem;
        height: 0.45rem;
      }

      .reward-icon {
        font-size: 0.45rem;
      }
    }
  }
}

.post-list .post-item.is-self {
  .post-footer .post-actions .action-item {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }
}

.loading {
  text-align: center;
  padding: 1rem 0;
  color: #999;
  font-size: 0.3rem;
}

.empty-state {
  text-align: center;
  padding: 2rem 0;

  .empty-icon {
    width: 2rem;
    height: 2rem;
    margin-bottom: 0.3rem;
  }

  .empty-text {
    font-size: 0.3rem;
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/plazzaSearch.vue